// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.main {
  width: 90%;
  padding: 0px 10px;
  margin: 0px auto;
  margin-top: 4rem;
}

.greet-main {
  max-width: 1370px;
  padding: 10px 10px;
  margin: 0px auto;
  margin-top: 2rem;
  display: block;
}

.greeting-main {
  display: flex;
  /* text-align: center; */
}

.greeting-main > * {
  flex: 1 1;
  margin-bottom: 30px;
}

.button-greeting-div {
  display: flex;
  margin-top: 20px;
}

.greeting-text {
  margin-top: 110px;
  font-size: 70px;
  line-height: 5px;
  font-family: "Be Vietnam Pro";
}

.greeting-nickname {
  font-size: 30px;
  line-height: 0px;
  font-family: "Be Vietnam Pro";
}

.greeting-text-p {
  font-size: 30px;
  line-height: 40px;
  margin-right: 40px;
  font-family: "Be Vietnam Pro";
}

.greeting-image-div > * {
  max-width: 100%;
  height: auto;
}

.button {
  text-decoration: none;
  color: rgba(255, 255, 255, 1);
  padding: 15px 15px;
  margin-top: 25px;
  border-radius: 4px;
  border-width: 0px;
  margin-bottom: 20px;
  width: 200px;
  height: 50px;
  font-weight: bold;
  font-family: "Google Sans Regular";
  font-size: 17px;
  transition: all 0.2s ease-in-out;
  cursor: pointer;
}

/* Media Query */
@media (max-width: 1380px) {
  .greeting-text {
    font-size: 50px;
  }

  .greeting-text-p {
    font-size: 20px;
  }

  .greet-main {
    max-width: 900px;
  }
}
@media (max-width: 768px) {
  .button-greeting-div {
    justify-content: space-around;
  }
  .greeting-text {
    font-size: 30px;
    margin-top: 0px;
    text-align: center;
  }
  .greeting-nickname {
    font-size: 25px;
    text-align: center;
  }
  .greeting-text-p {
    font-size: 16px;
    margin-right: 0px;
    line-height: normal;
    text-align: center;
  }
  .greeting-main {
    display: block;
  }

  .portfolio-repo-btn-div {
    width: 100%;
    display: flex;
    justify-content: center;
    text-align: center;
  }
}
`, "",{"version":3,"sources":["webpack://./src/containers/greeting/Greeting.css"],"names":[],"mappings":"AAAA;EACE,UAAU;EACV,iBAAiB;EACjB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,wBAAwB;AAC1B;;AAEA;EACE,SAAO;EACP,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,6BAA6B;AAC/B;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,6BAA6B;AAC/B;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,6BAA6B;AAC/B;;AAEA;EACE,eAAe;EACf,YAAY;AACd;;AAEA;EACE,qBAAqB;EACrB,6BAA6B;EAC7B,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB,iBAAiB;EACjB,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,iBAAiB;EACjB,kCAAkC;EAClC,eAAe;EACf,gCAAgC;EAChC,eAAe;AACjB;;AAEA,gBAAgB;AAChB;EACE;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,gBAAgB;EAClB;AACF;AACA;EACE;IACE,6BAA6B;EAC/B;EACA;IACE,eAAe;IACf,eAAe;IACf,kBAAkB;EACpB;EACA;IACE,eAAe;IACf,kBAAkB;EACpB;EACA;IACE,eAAe;IACf,iBAAiB;IACjB,mBAAmB;IACnB,kBAAkB;EACpB;EACA;IACE,cAAc;EAChB;;EAEA;IACE,WAAW;IACX,aAAa;IACb,uBAAuB;IACvB,kBAAkB;EACpB;AACF","sourcesContent":[".main {\n  width: 90%;\n  padding: 0px 10px;\n  margin: 0px auto;\n  margin-top: 4rem;\n}\n\n.greet-main {\n  max-width: 1370px;\n  padding: 10px 10px;\n  margin: 0px auto;\n  margin-top: 2rem;\n  display: block;\n}\n\n.greeting-main {\n  display: flex;\n  /* text-align: center; */\n}\n\n.greeting-main > * {\n  flex: 1;\n  margin-bottom: 30px;\n}\n\n.button-greeting-div {\n  display: flex;\n  margin-top: 20px;\n}\n\n.greeting-text {\n  margin-top: 110px;\n  font-size: 70px;\n  line-height: 5px;\n  font-family: \"Be Vietnam Pro\";\n}\n\n.greeting-nickname {\n  font-size: 30px;\n  line-height: 0px;\n  font-family: \"Be Vietnam Pro\";\n}\n\n.greeting-text-p {\n  font-size: 30px;\n  line-height: 40px;\n  margin-right: 40px;\n  font-family: \"Be Vietnam Pro\";\n}\n\n.greeting-image-div > * {\n  max-width: 100%;\n  height: auto;\n}\n\n.button {\n  text-decoration: none;\n  color: rgba(255, 255, 255, 1);\n  padding: 15px 15px;\n  margin-top: 25px;\n  border-radius: 4px;\n  border-width: 0px;\n  margin-bottom: 20px;\n  width: 200px;\n  height: 50px;\n  font-weight: bold;\n  font-family: \"Google Sans Regular\";\n  font-size: 17px;\n  transition: all 0.2s ease-in-out;\n  cursor: pointer;\n}\n\n/* Media Query */\n@media (max-width: 1380px) {\n  .greeting-text {\n    font-size: 50px;\n  }\n\n  .greeting-text-p {\n    font-size: 20px;\n  }\n\n  .greet-main {\n    max-width: 900px;\n  }\n}\n@media (max-width: 768px) {\n  .button-greeting-div {\n    justify-content: space-around;\n  }\n  .greeting-text {\n    font-size: 30px;\n    margin-top: 0px;\n    text-align: center;\n  }\n  .greeting-nickname {\n    font-size: 25px;\n    text-align: center;\n  }\n  .greeting-text-p {\n    font-size: 16px;\n    margin-right: 0px;\n    line-height: normal;\n    text-align: center;\n  }\n  .greeting-main {\n    display: block;\n  }\n\n  .portfolio-repo-btn-div {\n    width: 100%;\n    display: flex;\n    justify-content: center;\n    text-align: center;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
